// @ts-nocheck

/**
 * Set item freebetId as boolean to be use as freebet balance
 * @param  {Object} state        The actual state.
 * @param  {Object} action       The action to reduce.
 * @return {Object}              Return the new state.
 */
const basketSetIsGRActive = (state, action) => {
  const { isGRActive } = action.payload;

  return {
    ...state,
    isGRActive,
    selectedFreebetId: isGRActive ? undefined : state.selectedFreebetId,
  };
};

export default basketSetIsGRActive;
